// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConsentCheckbox-module__wrapper___ozvzw","text":"ConsentCheckbox-module__text___1hOm_"};